import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { InputGroup } from "@Components/Input/InputGroups"
import { Spacer } from "@Components/Space"
import React, { useEffect, useState } from "react"
import { Dimensions, ScrollView, StyleSheet, TouchableOpacity, View, ViewBase } from "react-native"
const moment = require("moment")
import localization from "moment/locale/fr"
import DateTimePicker from "@react-native-community/datetimepicker"
import { FreeTimeSelector } from "@Components/Input/FreeTimeSelector"
import { capitalizeFirstLetter, convertToTimeZoneDate, generateUUID } from "@Utils/utils"
import { baseColors } from "@Constants/baseStyles"
import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import DropDownPicker from "react-native-dropdown-picker"
import { Ionicons } from "@expo/vector-icons"
import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { CustomPicker } from "@Components/FollowUp/Toolbox/CustomPicker"
import { VideoPoint } from "@Screens/Diagnostic/VideoPoint"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { EventService } from "@Services/Event.Service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { DiagnosisState, EventName, message } from "@Constants/constant"
import { userAtom } from "@Recoil/Atom/userAtom"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { currentDiagnosisAtom, diagnosisShouldUpdateAtom, diagnosisStatusAtom } from "@Recoil/Atom/DiagnosisAtom"
import { EducatifDiagnoseService } from "@Services/EducatifDiagnose.Service"

moment.locale("fr")

const { width, height } = Dimensions.get("screen")
export const ModalCreateVideoPoint = (props) => {
    const { toggleModal, openModal, redirectToHome } = props
    const questions = Array.from(Array(5).keys())
    const user = useRecoilValue(userAtom)
    const [saving, setSaving] = useState(false)
    const [loading, setLoading] = useState(false)
    const diagnosisStatus = useRecoilValue(diagnosisStatusAtom)
    const [appointement, setAppointment] = useState(null)
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)
    const [visioDiagnose, setVisioDiagnose] = useState(null)
    const [diagnosisShouldUpdate, setDiagnosisShouldUpdate] = useRecoilState(diagnosisShouldUpdateAtom)

    const fetchEvents = () => {
        setLoading(true)
        EventService.getUsersEvents(user.id)
            .then((response) => {
                const data = response.data?.data?.items
                if (data && data instanceof Array) {
                    let events = data.filter(
                        (item) =>
                            item?.eventType?.name == EventName.DIAGNOSTIC_EDUCATIF &&
                            !item?.dayHospital?.id &&
                            item?.summary === "Entretien Individuel"
                    )
                    if (events.length > 0) {
                        setVisioDiagnose(...events)
                    }
                }
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
            })
    }

    const performDeleteEvent = () => {
        if (visioDiagnose?.id) {
            EventService.deleteById(visioDiagnose)
                .then(() => {
                    performUpdateDiagnosisState(() => performSaveEvent())
                })
                .catch((e) => {
                    ShowToast({
                        type: "error",
                        message: "Une erreur est survenue lors de la suppression de l'ancien rendez-vous"
                    })
                })
        } else {
            performUpdateDiagnosisState(() => performSaveEvent())
        }
    }

    const performUpdateDiagnosisState = (callback) => {
        if (diagnosisStatus && diagnosisStatus.length > 0 && currentEducationalDiagnosis) {
            const pending = diagnosisStatus.filter((item) => item.code === DiagnosisState.PENDING)
            if (pending && pending.length > 0) {
                setSaving(true)
                EducatifDiagnoseService.updateEducationnalDiagnosis(
                    currentEducationalDiagnosis?.id,
                    pending[0]?.id
                ).then((response) => {
                    if (response.data?.code === 200) {
                        callback?.()
                    } else {
                        ShowToast({ type: "error", message: response?.data?.message })
                        setSaving(false)
                    }
                })
            } else {
            }
        } else {
        }
    }

    const performSaveEvent = () => {
        EventService.createCalendar(generateUUID())
            .then((response) => {
                const data = response.data?.data
                if (data && data instanceof Array && data.length > 0 && response.data?.code === 200) {
                    const id = data[0].id
                    const newEvent = {
                        ...appointement,
                        startDate: convertToTimeZoneDate(appointement.startDate),
                        endDate: convertToTimeZoneDate(appointement.endDate),
                        calendarId: id,
                        attendees: [...appointement.attendees, { id: user?.id, type: 1 }]
                    }
                    EventService.create(newEvent).then((response) => {
                        const data = response?.data
                        saveAppointmentCallback()
                    })
                } else {
                    ShowToast({ type: "error", message: response?.data?.data?.message })
                    setSaving(false)
                }
            })
            .catch((e) => {
                setSaving(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const saveAppointmentCallback = () => {
        setSaving(false)
        if (appointement) {
            ShowToast({ type: "success", message: "Entretien programmé" })
            //setFollowUpAppointments((old) => [...old, appointement])
            setAppointment(null)
            setDiagnosisShouldUpdate(!diagnosisShouldUpdate)
            redirectToHome?.()
        }
    }
    useEffect(() => {
        fetchEvents()
    }, [])
    return (
        <CustomBottomModal fullScreen permanent toggleModal={toggleModal} open={openModal}>
            <View style={{ height: "100%" }}>
                <CustomScrollview paddingTop={0}>
                    <View style={{ backgroundColor: baseColors.black, marginTop: -20 }}>
                        <Spacer height={20} />
                        <View style={{ backgroundColor: baseColors.black, padding: 20, paddingBottom: 50 }}>
                            <BreeSerifText textAlign={"center"} fontSize={22} color={baseColors.white}>
                                Rendez-vous
                            </BreeSerifText>
                            <Spacer height={10} />
                            <OpenSansText textAlign={"left"} fontSize={16} color={baseColors.white}>
                                Vous n'avez pas validé votre Diagnostic. Vous devez reprendre un rendez-vous.
                            </OpenSansText>
                        </View>
                        <View style={styles.overlay}>
                            <VideoPoint
                                disabled={saving}
                                eventType={EventName.DIAGNOSTIC_EDUCATIF}
                                handleChange={(apntment) => setAppointment(apntment)}
                            />
                            <View style={styles.row}>
                                <Button
                                    text="Précédent"
                                    width="40%"
                                    onPress={() => {
                                        toggleModal?.()
                                    }}
                                    backgroundColor={baseColors.green.light}
                                    labelColor={baseColors.green.dark}
                                />
                                <Button
                                    text={"Confirmer"}
                                    width="40%"
                                    disabled={!appointement || saving}
                                    loading={saving}
                                    onPress={() => {
                                        performDeleteEvent()
                                    }}
                                    backgroundColor={baseColors.green.primary}
                                    labelColor={"white"}
                                />
                            </View>
                        </View>
                    </View>
                </CustomScrollview>
            </View>
        </CustomBottomModal>
    )
}

const styles = StyleSheet.create({
    overlay: {
        marginTop: -15,
        width: "100%",
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        backgroundColor: "white",
        padding: 20
    },
    row: {
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between"
    }
})
